// extracted by mini-css-extract-plugin
export var aboutCompanySection = "about-us-module--about-company-section--Qyq+L";